/* eslint-disable */

<template>
  <div class="main">
    <slider animation="fade" :duration="5000" :speed="5000" :interval="3000">
      <slider-item v-for="(i, index) in list" :key="index">
        <img :src="require('../assets/banner/s/a' + i + '.jpg')" alt="image1" />
      </slider-item>
    </slider>
  </div>
</template>

<script>
import FadeTransition from "@/components/FadeTransition.vue";
import EasySlider from "vue-easy-slider";
import UsageGuide from "../components/UsageGuide.vue";
import SideTabs from "../components/SideTabs.vue";

export default {
  name: "Home",
  components: {
    EasySlider,
    FadeTransition,
    UsageGuide,
    SideTabs,
  },
  data() {
    return {
      list: [],
      modalVisible: false,
      showCorpus: false,
      showPRL: false,
      showTeam: false,
      showUsage: false,
      data: [
        '<div class="example-slide">Slide 1</div>',
        '<div class="example-slide">Slide 2</div>',
        '<div class="example-slide">Slide 3</div>',
      ],
      error: "Server Not Responding",
      error_msg:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat qui labore alias voluptatum quas omnis ducimus ipsam itaque aperiam, minima, nemo assumenda voluptates quae laudantium quidem obcaecati totam, id velit",
      error_visible: false,
    };
  },
  methods: {
    testError() {
      this.$alert("msg", "Server Not Responding", "error");
    },
    redirectUser: function (path) {
      this.testBool = false;
      this.$router.push(path);
    },
    resetSection() {
      this.showCorpus = false;
      this.showTeam = false;
      this.showPRL = false;
      this.showUsage = false;
    },
    toggleModal(section) {
      this.resetSection();
      this.modalVisible = !this.modalVisible;
      if (section === "Corpus") {
        this.showCorpus = true;
      } else if (section === "Tools") {
        this.showTools = true;
      } else if (section === "Team") {
        this.showTeam = true;
      } else if (section === "PRL") {
        this.showPRL = true;
      } else if (section === "usage") {
        this.showUsage = true;
      }
    },
    buildSlideMarkup: function (count) {
      let slideMarkup = "";
      for (var i = 1; i <= count; i++) {
        slideMarkup += '<slide><span class="label">' + i + "</span></slide>";
      }
      return slideMarkup;
    },
    loadImg() {
      this.isLoad = false;
      this.$nextTick(() => {
        this.url = this.images[this.index];
        this.index = this.index < this.images.length - 1 ? this.index + 1 : 0;
      });
    },
    loaded() {
      this.isLoad = true;
    },
  },
  mounted() {
    while (this.list.length < 15) {
      var r = Math.floor(Math.random() * 130) + 1;
      let id = ("00" + r).slice(-3);
      if (this.list.indexOf(id) === -1) this.list.push(id);
    }
  },
};
</script>

<style scoped>
.main {
  background-color: rgba(255, 255, 255, 1);
  overflow-x: hidden;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0;
  padding-top: 0;
}
.hover-buttons {
  z-index: 999;
  position: absolute;
  top: 0%;
  left: 0%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.hover-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;
  width: 12rem;
  color: rgb(0, 0, 0);
  background-color: rgb(255, 255, 255);
  margin-bottom: 1rem;
  border: none;
  outline: none;
  padding-top: 0.2rem;
  box-shadow: 0 3px 10px rgb(65, 65, 65);
}
.hover-btn:hover {
  transform: scaleX(1.05);
  color: white;
  background-color: var(--grey_black);
  box-shadow: 0 0 5px #0f0f0f75;
}
@media only screen and (max-width: 768px) {
  .modal-body {
    margin: 0 5vw !important;
  }
  .modal-body span {
    width: 100%;
  }
}
.about-modal {
  z-index: 9999;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.534);
}
.modal-body {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40%;
  max-height: 80%;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 5px 15px #0f0f0fdd;
  margin: 0 15vw;
  padding-top: 4rem;
  overflow: hidden;
}
.modal-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 3rem;
  height: 3rem;
  color: rgb(105, 105, 105);
  background-color: white;
  border: none;
  outline: none;
  font-weight: bold;
}
.modal-close-btn:hover {
  font-size: 1.2rem;
}
.magic-box {
  height: 200vh;
  width: 100px;
  background-color: rgb(140, 140, 140);
}
.carousel {
  z-index: 5;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0%);
  height: 100%;
  width: 100%;
  background-color: rgb(153, 153, 153);
}
.home-content {
  display: none;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(199, 199, 199, 0.467);
  margin-bottom: 0rem;
}
.about {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 80%;
  margin-top: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.542);
}
.about-text {
  width: 80%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1rem;
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
}
.about-text p {
  text-justify: inter-character;
  text-align: justify;
  font-size: 1rem;
}
.about p {
  text-justify: newspaper;
}
.about-text span p {
  text-justify: newspaper;
}
</style>

<style>
.swal2-styled.swal2-confirm {
  background-color: #f27474 !important;
}
.VueCarousel-navigation-button {
  height: 100%;
  width: 3rem;
  font-size: 2rem;
  color: rgb(140, 140, 140) !important;
  -webkit-text-stroke-width: 3px;
  -webkit-text-stroke-color: rgb(255, 255, 255);
  background-color: rgba(0, 0, 0, 0) !important;
}

.VueCarousel-navigation-prev {
  background: linear-gradient(
    0deg,
    rgb(255, 255, 255) 50%,
    rgba(255, 255, 255, 0) 50%
  );
}
.VueCarousel-navigation-next {
  background: linear-gradient(
    180deg,
    rgba(153, 153, 153, 0) 100%,
    rgb(153, 153, 153) 100%
  );
}
.VueCarousel-navigation--disabled {
  background: linear-gradient(
    180deg,
    rgba(153, 153, 153, 0) 100%,
    rgb(153, 153, 153) 100%
  );
}
.VueCarousel-slide {
  height: calc(100vh - 160px);
  text-align: center;
  background-color: rgba(43, 214, 226, 0);
  margin-top: 00px;
  margin-bottom: 10px;
}
.VueCarousel-slide img {
  position: relative;
  width: 100%;
  top: -25%;
}
.VueCarousel-dot {
  display: none !important;
  background-color: rgb(255, 255, 255) !important;
  margin-top: 0 !important;
}
.VueCarousel-dot--active {
  background-color: rgb(73, 73, 73) !important;
}
.VueCarousel-pagination {
  height: 70px;
  margin-top: 20px;
  background-color: rgb(45, 45, 55) !important;
  display: none;
}
.main,
.slider {
  min-height: calc(100vh - 120px) !important;
  width: 100% !important;
}
.slider-item {
  min-height: calc(100vh - 160px);
  width: 100% !important;
}
.slider-item img {
  min-height: calc(100vh - 160px);
  width: 100% !important;
}
@media only screen and (max-width: 769px) {
  .hover-buttons {
    margin-top: 90px;
  }
}
</style>

<style>
.slider-indicators,
.slider-indicators-center,
.slider-btn,
.slider-btn-left,
.slider-btn-right {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue